import React from "react";
import Banner from "./Banner";
import { useEffect, useState } from "react";
const RefundPolicy = () => {
  const [htmlContent, setHtmlContent] = useState("");
      
        useEffect(() => {
          fetch("/PolicyPage/refundpolicy.txt")
            .then((response) => response.text())
            .then((data) => setHtmlContent(data))
            .catch((error) => console.error("Error loading HTML file:", error));
        }, []);
  return (
    // <div className="w-full min-h-screen py-6 md:py-10 px-3 md:px-6 lg:px-8">
    //   <div className="space-y-6 mx-auto w-full max-w-7xl">
    //     <h1 className="font-semibold text-center text-[#0F172A] text-3xl md:text-4xl lg:text-5xl">
    //       Refund Policy
    //     </h1>
    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       We do not provide free trials in general, and all services are paid
    //       only. On a client’s specific request, we provide one trade as a trial
    //       to evaluate our services and support system. We expect that the client
    //       is satisfied before making the payment, therefore we,
    //       <strong> NextEra Research </strong>, have no refund policy at all.
    //     </p>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       By making the payment for our services, we assume that the client has
    //       been convinced in the initial communication or has availed of the free
    //       trial, read the disclosure, and made the payment only after being
    //       satisfied with the quality of services and support from
    //       <strong> NextEra Research </strong>.
    //     </p>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       We provide our best efforts and are confident about the quality of
    //       services that we provide. We aim to offer the same level of services
    //       during the trial trade as well as after that, therefore there is no
    //       refund policy or cancellation of payment.
    //     </p>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       Before deciding to subscribe to our services, please thoroughly review
    //       our website. Ensure that all your credit cards and passwords are
    //       secure and not disclosed to anyone. No one can make a payment for your
    //       account, and your membership is secured.
    //     </p>
    //   </div>
    //   <Banner />
    // </div>
    <div className="py-12" dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
};

export default RefundPolicy;
